import { atom } from 'jotai'

export const globalSettingsAtom = atom(null)
export const sitesAtom = atom([])
